export const DEFAULT_TABLE_ROWS = 3;
export const DEFAULT_TABLE_COLS = 3;
export const DEFAULT_TABLE_CELL_WIDTH = 220;
export const DEFAULT_TABLE_WIDTH = DEFAULT_TABLE_CELL_WIDTH * DEFAULT_TABLE_COLS;
export const DEFAULT_TABLE_HEIGHT = 200;
export const DEFAULT_TABLE_ROW_HEIGHT = DEFAULT_TABLE_HEIGHT / DEFAULT_TABLE_ROWS;
export const MIN_TABLE_ROW_HEIGHT = 40;
export const MIN_TABLE_COL_WIDTH = 100;
export const REDUCED_MIN_TABLE_COL_WIDTH = 40;
/**
 * Fixed width (in world units / px) of the optional left-side numbered-row
 * column. Mirrors the Confluence Pages "numbered column" decoration: the
 * strip is rendered to the left of the editable cells, is non-interactive,
 * and is not part of the table's `colOrder` data.
 */
export const NUMBERED_ROW_COLUMN_WIDTH = 42;
